export const environment = {
  configLocation: 'config-onprem.json',
  production: false,
  BaseUrl: "http://a193.193.123.49/IntegrationAPI",
  authorizeIframeResponseOrigin: "https://authorize-ui.rguest.com",
  rGuestPayIframeResponsOrigin: 'https://pay-blue.hospitalityrevolution.com',
  commonErrorMessage: "Oops!... Some unexpected error occurred!",
  defaultPropertyName: "Restaurant",
  generalPropertyName: "Property",
  redirectToAdminPortal: "http://193.193.123.49/MP",
    SEAProduction : true,
  restaurantIds : [6,7,2156],
  app_base_href: "/Widget",
  NotesAsTagsMerchantIds: [],
  restaurantIdshowSMSRemainder: [],
  restaurantIdToHideLanguages:[]
};
